function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="86" height="87" viewBox="0 0 86 87" {...props}><path d="M75.25.979h-64.5C4.84.979 0 5.809 0 11.729v64.5c0 5.91 4.84 10.75 10.75 10.75h32.62v-30.84h-10.3v-13.43h10.3v-6.73c0-10.38 7.66-18.5 17.44-18.5h9.49v15.16h-8.49c-2.22 0-2.87 1.28-2.87 3.04v7.03H70.3v13.43H58.94v30.84h16.31c5.91 0 10.75-4.84 10.75-10.75v-64.5C86 5.809 81.16.979 75.25.979" fillRule="evenodd" /></svg>;
});